import React, { useState } from 'react'
import classNames from 'classnames';
import './HowToBuyAccordion.module.scss'
import { MINUS_ICON, PLUS_ICON, HOW_TO_BUY } from '../../../shared/constants';
import HomepageSlider from '../../../components/Slider/HomepageSlider'

const HowToBuyAccordion = (props) => {
  const { category } = props

  return (
    <div className='accordion-wrapper'>
      <div className='accordion-container'>
        <div className='accordion-section'>
          <AccordionItem
            category={category}
          />
        </div>
      </div>
    </div>
  );
}


const AccordionItem = (props) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const toggleIsExpanded = () => setIsExpanded(!isExpanded);

  const { category } = props;
  let data = HOW_TO_BUY[category];

  return (
    <div
      className={classNames('accordion', isExpanded && 'active')}
    >
      <div
        onClick={toggleIsExpanded}
        className='accordion-header'>
        <span className='accordion-label'>{data.title}</span>
        <img
          className='accordion-icon'
          src={isExpanded ? MINUS_ICON : PLUS_ICON}
          alt="" />

      </div>
      {isExpanded && <Content data={data} />}
    </div>
  );
}

const Content = (props) => {
  const { data } = props;

  return (
    <>
      <div>
        <HomepageSlider

          isHomepage={false}
          sliderData={{
            desktop: {
              height: 450,
              width: 300,
              visibleItems: 5,
            },
            mobile: {
              height: 200,
              width: 220,
              outterHorizontalPadding: 28,
            },
          }}
          items={
            data.content.map((item, idx) =>
              <SliderCard
                data={item}
                index={idx + 1}
              />
            )

          }
        />
        <div className='document-title'>Dokumen yang dibutuhkan</div>
        <div className='document-subtitle'>{data.documents}</div>
      </div>
    </>
  );
}

const SliderCard = (props) => {
  const { data, index } = props;

  return (
    <>
      <div className='carousel-card'>
        <div className='corner-frame-container'>
          <img
            className='corner-frame-image'
            src='/static/images/how-to-buy/corner-frame.svg'
            alt="" />
          <div className='corner-number'>{index}</div>
        </div>
        <div className='carousel-content'>
          <img
            className='image'
            src={data.image}
            alt="" />
          <div className='text' dangerouslySetInnerHTML={{ __html: data.text }}></div>
        </div>
      </div>
    </>
  );
}

export default HowToBuyAccordion;